module.exports = __webpack_public_path__ + "img/stylish.ba104c61.png";